import { z } from 'zod';

/**
 * Moyasar refuses to render its form for a charge under 100 halalas, so a
 * course priced below one riyal is published but impossible to buy.
 */
const MINIMUM_SAR = 1;

/**
 * The admin types riyals; the API stores halalas. Keeping the conversion here
 * means the two course forms cannot drift on which unit they are holding.
 */
export const priceField = z
  .number({ error: 'Price is required' })
  .min(MINIMUM_SAR, { message: 'Price must be at least 1.00 SAR' });

export function toHalalas(sar: number) {
  return Math.round(sar * 100);
}

export function toSar(halalas: number | null) {
  return halalas === null ? Number.NaN : halalas / 100;
}
